import { useTranslation } from 'react-i18next';
import { ConstellationDivider } from 'shared/components/ConstellationDivider/ConstellationDivider';
import { Heading } from 'shared/components/Heading';
import { Quote } from 'shared/components/Quote';
import type { ShowNotes } from 'shared/data/episodes';

type ShowNotesSectionProps = {
  showNotes: ShowNotes;
};

export function ShowNotesSection({ showNotes }: ShowNotesSectionProps) {
  const { t } = useTranslation('episodeDetail');
  return (
    <div id="show-notes" className="lg:col-span-7">
      <Heading variant="section" className="mb-12 flex items-center gap-4 md:text-4xl">
        {t('showNotes.title')}
        <ConstellationDivider className="opacity-40" />
      </Heading>

      <div className="space-y-10 text-on-surface-variant font-light leading-relaxed text-lg">
        <p>{showNotes.intro}</p>

        {showNotes.quote && (
          <Quote variant="card" attribution={showNotes.quote.attribution}>
            {showNotes.quote.text}
          </Quote>
        )}

        <Heading variant="card" className="text-on-surface mt-16 mb-6">
          {t('showNotes.discussionHeading')}
        </Heading>
        <ol className="space-y-6">
          {showNotes.discussionPoints.map((point, index) => (
            <li key={point.title} className="flex gap-4">
              <span className="text-tertiary font-serif italic text-2xl">
                {String(index + 1).padStart(2, '0')}.
              </span>
              <div>
                <h4 className="text-on-surface font-semibold mb-1">
                  {point.title}
                </h4>
                <p>{point.description}</p>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </div>
  );
}
